import { GrpcObject, ServiceClientConstructor, ServiceDefinition, UntypedServiceImplementation, loadPackageDefinition } from "@grpc/grpc-js";
import { loadProto } from "./tools.ts";
import { PackageDefinition } from "@grpc/proto-loader";

export type ServiceOptions = {
    path: string
    package: string
    service: string
}

export type GrpcService = {
    service: ServiceDefinition,
    mapper: UntypedServiceImplementation
}

export default (options: ServiceOptions, mapper: UntypedServiceImplementation): GrpcService => {
    const definition: PackageDefinition = loadProto(options.path);
    const grpcObject: GrpcObject = loadPackageDefinition(definition);
    const grpcPackage: GrpcObject = grpcObject[options.package] as GrpcObject;
    const grpcService = grpcPackage[options.service] as ServiceClientConstructor;
    return { service: grpcService.service, mapper }
}